import { render } from "./UserProfile.vue?vue&type=template&id=b9518182&ts=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=b9518182&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__